import React , { useState, useEffect } from 'react';
import { Select } from '@windmill/react-ui';
import AgentsServices from 'services/AgentsServices';

const Selectseller = ({register, name, label, selectedTransHead, setSelectedTransHead  }) => {
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    async function fetchProfiles() {
      try {
        const response = await AgentsServices.getSeller();
        setProfiles(response.data); 
      } catch (error) {
        console.error('Error fetching Transport Head:', error);
      }
    }
  
    fetchProfiles();
  }, []);

  const handleChange = (e) => {
    setSelectedTransHead(e.target.value); 
  };
  return (
    <Select
    className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
    name={name}
    value={selectedTransHead || ""}
    {...register(`${name}`, {
      required: `${label} is required!`,
    })}
    onChange={handleChange}  
  >
    <option value="" hidden>Select Seller</option>
    {Array.isArray(profiles) && profiles.length > 0 ? (
      profiles.map((profile) => (
        <option key={profile.id_employee} value={profile.id_employee}>
          {profile.employee_name}
        </option>
      ))
    ) : (
      <option>Loading...</option>
    )}
  </Select>
    
  );
};

export default Selectseller;
